<template>
  <div class="row justify-content-center">
    <div class="col-sm-12">
      <BarChart v-bind:chartLabels="this.chartLabels" v-bind:dataValues="this.dataValues"
        v-bind:axisLabel="this.axisLabel" :height="chartHeight" :styles="canvasStyles">
      </BarChart>
    </div>
  </div>
</template>

<script>
import BarChart from './BarChart.vue';

export default {
  name: 'BlockBar',
  components: {
    BarChart
  },
  props: {
    chartLabels: Array,
    dataValues: Array,
    axisLabel: String
  },
  data: function () {
    return {
      chartHeight: (this.dataValues.length * 30) + 60
    }
  },
  computed: {
    canvasStyles: function () {
      return {
        height: `${(this.dataValues.length * 30) + 60}px`,
        'margin-bottom': '1em'
      }
    }
  }
}
</script>
